import React from "react";
import { TableCell, TableRow } from "../../../shadcn/components/ui/table";

const UserClubTableRow = ({ data = {}}) => {

  return (
        <TableRow>
            <TableCell role="rowheader" className="px-4 font-medium">
                {data?.name}
            </TableCell>
            <TableCell className="px-4">
                {data?.isPremium? 'Yes' : 'No'}
            </TableCell>
        </TableRow>
  );
};

UserClubTableRow.propTypes = {};

export default UserClubTableRow;
